enum ErrorStatus {
  SUBMISSION_ERROR = 'SubmissionFailed',
  CREDIT_CARD_DECLINE_RETRY_ERROR = 'RetryCreditCardFailed',
  CREDIT_CARD_DECLINE_NEW_ERROR = 'NewCreditCardFailed',
  CREDIT_CARD_DECLINE_NO_PENDING_ORDERS_ERROR = 'NoPendingOrders',
  CREDIT_CARD_DECLINE_PARTIAL_SHOPPING_CART_ERROR = 'InitializePartialShoppingCartError',
  THREE_DS_ERROR = 'ThreeDSError',
  FETCH_EXPERIENCE_ERROR = 'FetchExperienceFailed',
  EXCEED_MAX_POLL_COUNT_ERROR = 'ExceedMaxPollCount',
  WCI_CALLBACK_URL_VALIDATION_ERROR = 'WCICallbackUrlValidationError',
  REBOARD_FAILED_ERROR = 'ReboardFailed',
  NO_CART_ITEM_ERROR = 'NoCartItem',
  LOYALTY_SSO_ERROR = 'LoyaltySSOError',
  LOYALTY_TOKEN_LOGIN_ERROR = 'LoyaltyTokenLogInError',
  LOYALTY_ACCOUNT_DETAIL_ERROR = 'LoyaltyAccountDetailError',
  ELIGIBILITY_WIDGET_ERROR = 'EligibilityWidgetError',
  PARTNER_TAG_MANAGER = 'PartnerTagManager',
  EMPTY_SEATMAP = 'EmptySeatMap',
  SEATSHOP_NO_INSTANT_PURCHASE_VARIANT = 'SeatshopNoInstantPurchaseVariant',
}
export default ErrorStatus;

export enum GenericErrorStatus {
  APOLLO_ERROR = 'ApolloError',
}
